import { useState } from 'react'
import * as React from 'react'
import ChatbotWrapper from '../Containers/ChatbotWrapper.jsx'
import useIframeHeight from '../Hooks/useIframeHeight.js'
import { useInitialMessages } from '../Hooks/initialMessages.js'

const App = () => {
  const [isChatOpen, setIsChatOpen] = useState(false)

  useIframeHeight(isChatOpen)

  const { loading } = useInitialMessages()

  return (
    <div className="App">
      {loading ? (
        <div className="loading-message">Carregando...</div>
      ) : (
        <ChatbotWrapper onToggleChat={() => setIsChatOpen((prev) => !prev)} />
      )}
    </div>
  )
}

export default App